<template>
    <div class="vrm-widget vrm-widget-skeleton">
        <div class="vrm-widget__header vrm-widget__header--oneline">
            <div class="vrm-widget__header__title"></div>
        </div>
        <div class="vrm-widget__items"></div>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class VrmWidgetSkeleton extends Vue {}
</script>
